// jan 9 2026

"use client";
import { createContext } from "react";

export const UIContext = createContext({
  thisUser: null, setThisUser: () => {},
  actor: null, setActor: () => {},
  chatModalOpen: false, setChatModalOpen: () => {},
  supportModalOpen: false, setSupportModalOpen: () => {},
  notificationsModalOpen: false, setNotificationsModalOpen: () => {},
  chatNotificationsModalOpen: false, setChatNotificationsModalOpen: () => {},
  success: false, setSuccess: () => {},
  error: false, setError: () => {},
  loading: false, setLoading: () => {},
  hint: false, setHint: () => {},
  sideNavbarPinned: false, setSideNavbarPinned: () => {},
  sideNavbarHovering: false, setSideNavbarHovering: () => {},
});